import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';

type DeleteRuleModalProps = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
};

const DeleteRuleModal = ({ open, onClose, onDelete }: DeleteRuleModalProps) => {
  return (
    <Modal
      open={open}
      customSize={{
        width: '600px',
        height: 'auto',
        maxWidth: 'calc(100vw - 80px)',
      }}
      contentWrapperClassName="padding-24"
      onRequestClose={onClose}
      RenderHeaderContent={() => {
        return (
          <Text color="var(--gray-300)" tag="h3" className="H3">
            Are you sure you want to delete this rule?
          </Text>
        );
      }}
      RenderFooterContent={() => {
        return (
          <Container className="flex fd-row jc-flex-end ai-center">
            <Button onClick={onClose} design="LocalBttnSec" className="padding-v-8 padding-h-16 margin-r-8">
              Cancel
            </Button>
            <Button
              width="105px"
              className="padding-v-8 padding-h-16"
              design="LocalBttnPrim"
              onClick={onDelete}
              backgroundColor={getThemeColorCSSVariable()}
            >
              Delete
            </Button>
          </Container>
        );
      }}
    >
      <Text color="var(--semantic-red-400)" tag="p" className="P margin-t-32">
        This action cannot be undone.
      </Text>
    </Modal>
  );
};

export default DeleteRuleModal;
